import { useEffect } from "react";
import Navbar from "./components/Navbar";
import BioHero from "./components/BioHero";
import BioHowItWorks from "./components/BioHowItWorks";
import BioWhy from "./components/BioWhy";
import MetaVsKwai from "./components/MetaVsKwai";
import CampaignsShowcase from "./components/CampaignsShowcase";
import BioCTA from "./components/BioCTA";
import Footer from "./components/Footer";
import { initTracking } from "@/lib/tracking";

export default function Home() {
  useEffect(() => {
    initTracking();
  }, []);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <BioHero />
        <BioHowItWorks />
        <BioWhy />
        <MetaVsKwai />
        <CampaignsShowcase />
        <BioCTA />
      </main>
      <Footer />
    </div>
  );
}